import { createRefMemo } from '@/shared/libs/create-ref-memo';
import type { GameCatalogItem } from './types';

export const getGamesByFilter = createRefMemo(
  (gameData: GameCatalogItem[] | undefined) => {
    const index = new Map<string, GameCatalogItem[]>();
    for (const game of gameData ?? []) {
      for (const filter of game.filters ?? []) {
        const bucket = index.get(filter);
        if (!bucket) index.set(filter, [game]);
        else if (bucket[bucket.length - 1] !== game) bucket.push(game);
      }
    }
    return index;
  }
);
